import React from "react";
import { useCurrentPath } from "../../hooks";
import type { RouteMap } from "../../pages/MainAppPage/types";
import { DashboardNavLinks } from "./DashboardNavLinks";
import { AdminRouteMap } from "@/pages/AdminAppPage/types";

export type DashboardSideNavProps = {
  routes: RouteMap;
  adminRoutes: AdminRouteMap;
  admin?: boolean;
  unreadQuoteCount?: number;
  incomingOrgInvitationCount?: number;
  hasWebsite?: boolean;
  hasJobSitePhotos?: boolean;
  hasCredentials?: boolean;
  canAccessBackend?: boolean;
};

export const DashboardSideNav: React.FC<DashboardSideNavProps> = ({
  routes,
  adminRoutes,
  admin = false,
  unreadQuoteCount = 0,
  incomingOrgInvitationCount = 0,
  hasWebsite = false,
  hasJobSitePhotos = false,
  hasCredentials = false,
  canAccessBackend = true,
}) => {
  const currentPath = useCurrentPath();

  return (
    <aside className="hidden md:flex fixed left-0 top-[var(--ds-app-header-height)] bottom-0 w-56 bg-card border-r border-border flex-col shrink-0 z-40 shadow-[2px_0_8px_-4px_rgba(0,0,0,0.05)] overflow-x-clip">
      <nav className="flex-1 py-6 px-4 space-y-1.5 overflow-y-auto">
        <DashboardNavLinks
          routes={routes}
          currentPath={currentPath}
          unreadQuoteCount={unreadQuoteCount}
          incomingOrgInvitationCount={incomingOrgInvitationCount}
          variant="sidebar"
          adminRoutes={adminRoutes}
          admin={admin}
          hasWebsite={hasWebsite}
          hasJobSitePhotos={hasJobSitePhotos}
          hasCredentials={hasCredentials}
          canAccessBackend={canAccessBackend}
        />
      </nav>
    </aside>
  );
};
